import { Injectable } from '@angular/core';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

@Injectable({
    providedIn: 'root',
})
export class DHLConfigurationService {
    getGlobalConfigurationBySource(): {
        setChargesURL: string;
        enableAccesories: boolean;
    } {
        return {
            setChargesURL: '/search-awb/details',
            enableAccesories: true,
        };
    }

    getLaunchNewPortalDate(): dayjs.Dayjs {
        return dayjs.utc('2025-07-01T00:00:00Z');
    }
}
